import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/fee/itemset/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/fee/itemset/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/fee/itemset/remove', qs.stringify(params), options);

export const stopUse = (params, options) =>
  request.post('/api/fee/itemset/stopUse', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/fee/itemset/submit', params, options);

export const update = (params, options) => request.post('/api/fee/itemset/submit', params, options);

export const getLabelName = (params, options) =>
  request.get('/api/blade-system/dict/dicName', Object.assign({}, options, { params }));

export const getProperTree = (params, options) =>
  request.get('/api/base/property/tree', Object.assign({}, options, { params }));

export const getPropertyTreeByObjectTypeKey = (objectTypeKey, options) =>
  request.get(
    '/api/base/property/tree1?objectTypeKey=' + objectTypeKey,
    Object.assign({}, options, {})
  );
